import { createClient } from '@supabase/supabase-js';
import { navigatorLock } from '@supabase/auth-js';

/**
 * Shared anonymous Supabase client for public, unauthenticated reads on
 * marketing-layer pages/components (no Clerk JWT needed — RLS on these
 * tables already allows public SELECT). Distinct from the authenticated
 * singleton in services/supabaseClient.ts, which injects a Clerk JWT and
 * routes staging/prod by domain — this one is for content that's the same
 * for every visitor regardless of login state or environment.
 */
export const publicSupabaseClient = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: false,
      // `lockAcquireTimeout` isn't forwarded by supabase-js's `auth` options
      // (same issue fixed in services/supabaseClient.ts) — override `lock`
      // directly to actually raise it above GoTrue's hardcoded 10s default.
      lock: (name: string, _acquireTimeout: number, fn: () => Promise<any>) => navigatorLock(name, 60000, fn),
    },
  }
);
